// cxm-admin-web/src/container/label-template-management/components/preview.js

import React from 'react';
import { Card, Descriptions } from 'antd-v5';
import { JOB_STATUS } from '../index';

const Details = ({ data }) => {
  const { id, description, methodName, jobCron, jobStatus } = data;

  return (
    <Card>
      <Descriptions column={1} colon={false}>
        <Descriptions.Item label={<div style={{ width: 80 }}>任务ID</div>}>
          {id || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={<div style={{ width: 80 }}>任务描述</div>}>
          {description || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={<div style={{ width: 80 }}>方法名</div>}>
          {methodName || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={<div style={{ width: 80 }}>Cron表达式</div>}>
          {jobCron || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={<div style={{ width: 80 }}>运行状态</div>}>
          {jobStatus}
        </Descriptions.Item>
        <Descriptions.Item label={<div style={{ width: 80 }}>状态</div>}>
          {jobStatus === JOB_STATUS.NORMAL ? '启用' : '停用'}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default Details;
